export enum DemoUploadResult {
  SUCCESS = 'Success',
  ERROR = 'Error',
  INVALID = 'Invalid',
}
